import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import Store from '../../../Store/Store';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../Hooks/apis/useQuriesSuccess';
import { M_EMT_BASIC_Schema } from './M_EMT_BASIC_Schema';

/** 비상연락망 목록 조회 GetEmTelR1 (본인 부서) */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const userInfo = Store.getState()?.BaseInfo?.userInfo;
  const params = mapParamsBySchema(M_EMT_BASIC_Schema.mapper.search1, {
    userInfo,
  });

  const query = useQuery({
    queryKey: ['EmergencyTel', 'Basic', 'GetEmTelR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.EmergencyTel.GetEmTelR1, params),
    enabled: !!userInfo?.custCd,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
